/** 支付宝暂未开通时的统一提示 */
export const ALIPAY_DISABLED_HINT = "尚未开通，请使用微信支付";

export const ENTERPRISE_NOT_OPENED_TAG = "尚未开通";
export const ENTERPRISE_INSUFFICIENT_TAG = "余额不足";
export const ENTERPRISE_NOT_OPENED_TOAST =
  "请前往圆领 App 完成企业认证并充值后再使用企业余额支付";
export const ENTERPRISE_INSUFFICIENT_TOAST =
  "企业余额不足，请前往圆领 App 充值后再支付";

/** 支付成功后跳转订单合同列表 */
export const resolveCashierOrderListUrl = (): string =>
  `${window.location.origin}${window.location.pathname}#/order-contract`;

/** 轮询支付状态间隔（毫秒） */
export const PAY_STATUS_POLL_MS = 1500;

/** Web 收银台进入后是否默认发起微信支付并展示二维码 */
export const AUTO_SELECT_WECHAT_ON_WEB = true;

/**
 * 收银台视觉配置（Web 桌面端）。
 * 修改后保存即可生效，无需改 CSS；数值单位为 px 的写数字，颜色写 CSS 色值。
 */
export const CASHIER_VISUAL = {
  /** Web 主卡片圆角 */
  webCardBorderRadiusPx: 6,
  /** 支付方式选项卡圆角 */
  webMethodTileBorderRadiusPx: 6,
  /** 商品信息区域背景圆角 */
  webOrderBoxBorderRadiusPx: 6,
  /** 商品海报与下方订单信息区域的重叠高度（px） */
  webOrderPosterOverlapPx: 20,
  /** 「返回商户」文字链颜色 */
  webBackLinkColor: "#1677ff",
  /** 卡片底栏距顶部内边距 */
  webCardFootPaddingTopPx: 15,
  /** 卡片底栏距底部内边距 */
  webCardFootPaddingBottomPx: 16,
  /** 卡片底栏左右内边距 */
  webCardFootPaddingHorizontalPx: 28,
  /** Web 主卡片相对视口垂直居中时的偏移（px，正数偏上，负数偏下） */
  webCardVerticalOffsetUpPx: 20,
  /** Web 收银台微信支付二维码边长（px，宽高相同） */
  webQrCodeSizePx: 180,
  /** Web 收银台二维码生成时的 quiet zone 边距（px） */
  webQrCodeMarginPx: 2,
  /** Web 收银台二维码展示框内边距（px，展示框边长 = 二维码边长 + 2 × 本值） */
  webQrCodeBoxPaddingPx: 5,
} as const;
